export default {
  Dashboard: {
    SupportLoginDetail: {
      Header: 'وضعیت پشتیبان‌ها',
      NotFoundSupport: 'اطلاعات پشتیبان یافت نشد.',
      TableHeaders: {
        Support: 'پشتیبان',
        Login: 'ورود',
        Logout: 'خروج',
        Last_used: 'آخرین فعالیت',
        Status: 'وضعیت',
        Call: 'تماس',
      },
    },
  },
}
